export const FETCH_NEWS_ARTICLES = "FETCH_NEWS_ARTICLES";
